import LocationsListView from './LocationsListView';

export default LocationsListView;
